import React, { Fragment, useState } from 'react';
import { Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import EarnsTab from './EarnsTab';
import ReclamationsTab from './ReclamationsTab';

const EarnReclamation = () => {
  const [activeTab, setActiveTab] = useState('earns');

  return (
    <Fragment>
      <Breadcrumbs mainTitle="Gains & Réclamations" parent="Gestion" title="Gains & Réclamations" />
      <Container fluid={true}>
        <Row>
          <Nav className="border-tab nav-primary" tabs>
            <NavItem>
              <NavLink href="#javascript" className={activeTab === 'earns' ? 'active' : ''} onClick={() => setActiveTab('earns')}>
                Gains
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="#javascript" className={activeTab === 'reclamations' ? 'active' : ''} onClick={() => setActiveTab('reclamations')}>
                Réclamations
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab} className="w-100">
            <TabPane className="fade show" tabId="earns">
              {activeTab === 'earns' && <EarnsTab />}
            </TabPane>
            <TabPane className="fade show" tabId="reclamations">
              {activeTab === 'reclamations' && <ReclamationsTab />}
            </TabPane>
          </TabContent>
        </Row>
      </Container>
    </Fragment>
  );
};

export default EarnReclamation;
